import React from "react";
import { useCases } from "../data/siteData";

function UseCasesSection() {
  return (
    <section id="use-cases" className="section use-cases">
      <div className="use-cases__head">
        <p className="eyebrow center">See it in action</p>
        <h2 className="center">Three ways clinics use byond care every day.</h2>
        <p className="center">
          Story-driven, outcome-focused. See yourself in these workflows.
        </p>
      </div>
      <div className="use-cases__grid">
        {useCases.map((item) => (
          <article key={item.num} className="use-cases__card">
            <div className="use-cases__num">{item.num}</div>
            <h3>{item.title}</h3>
            <p className="use-cases__intro">{item.text}</p>
            <ul>
              {item.steps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ul>
            <div className="use-cases__outcome">{item.outcome}</div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default UseCasesSection;
